import DevicePairing from 'Components/device-pairing';

export default {
	name: 'DevicePairingModal',
	components: {
		DevicePairing
	},
	created() {
		this.devicesAtCreate = this.$store.state.devices.items.length;
	},
	mounted() {
		document.documentElement.style.overflow = 'hidden';
		document.body.scroll = 'no';
	},
	watch: {
		currentDevices(value) {
			if (value > this.devicesAtCreate) {
				this.$router.push('/');
			}
		},
	},
	data() {
		return {
			devicesAtCreate: 0
		};
	},
	computed: {
		currentDevices() {
			return this.$store.state.devices.items.length;
		}
	},
	methods: {
		close() {
			if (this.isFirstPairing) {
				this.$store.commit('FIRST_DEVICE_PAIR_SHOWED', { isFirstDevicePairingShowed: true });
			}

			this.$router.push('/');
		}
	},
	destroyed() {
		document.documentElement.style.overflow = 'auto';
		document.body.scroll = 'yes';
	}
};



// WEBPACK FOOTER //
// ./app/components/device-pairing-modal/script.js